import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { getTransCargoTypeLabel } from '../../../../../constants/constants';
import { useWeights } from '../../../../shared/hooks/use-weights';
import type { BulkDraftProjection } from '../bulk-drafts-types';

interface BulkPreviewTableBodyProps {
    finalProjections: BulkDraftProjection[];
}

export const BulkPreviewTableBody = (props: BulkPreviewTableBodyProps) => {
    const { finalProjections } = props;
    const { convertFromGramsDisplay } = useWeights();

    return (
        <TableBody className='bulk-entry-table-body'>
            {finalProjections.map((projection, i) => (
                <TableRow className='bulk-preview-table-row' key={i}>
                    <TableCell className='left-align'>{projection.numberOfLoads}</TableCell>
                    <TableCell className='left-align'>{projection.date.format('ddd MMM DD')}</TableCell>
                    <TableCell className='left-align'>{projection.orgLocation.name}</TableCell>
                    <TableCell className='left-align'>{getTransCargoTypeLabel(projection.cargoType.id)}</TableCell>
                    <TableCell className='left-align'>{projection.quantityPerLoad}</TableCell>
                    <TableCell className='left-align'>{projection.weightPerLoad ? convertFromGramsDisplay(projection.weightPerLoad) : ''}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    );
};
